import React from 'react'
import { Transition } from 'react-transition-group'
import TransitionGroup from 'react-transition-group/TransitionGroup'
import { CSSTransition } from 'react-transition-group'
import './loadingSwitch.css'

const duration = 200

const defaultStyle = {
  transition: `opacity ${duration}ms linear`,
  opacity: 0,
  position: 'relative'
}

const transitionStyles = {
  exited: { display: 'none' },
  entering: { opacity: 0 },
  entered: { opacity: 1 }
}

const Fade = ({ in: inProp, children }) => (
  <Transition in={inProp} timeout={duration}>
    {state => {
      return (
        <div
          style={{
            ...defaultStyle,
            ...transitionStyles[state]
          }}
        >
          {children}
        </div>
      )
    }}
  </Transition>
)

const LoadingSwitch = ({ loadingState, activeState, isLoading, crossfade }) => {
  if (crossfade) {
    const views = {
      active: activeState,
      loading: loadingState
    }
    const key = isLoading ? 'loading' : 'active'
    return (
      <TransitionGroup className="animated-loading-switch">
        <CSSTransition classNames="loading-fade" timeout={duration} key={key}>
          {views[key]}
        </CSSTransition>
      </TransitionGroup>
    )
  }
  return (
    <div>
      <Fade unmountOnExit={true} in={isLoading === true}>
        {loadingState}
      </Fade>
      <Fade in={isLoading === false}>{activeState}</Fade>
    </div>
  )
}

export default LoadingSwitch



// WEBPACK FOOTER //
// ./src/core/components/loading-switch/LoadingSwitch.js